import { itrustPayPaymentLogsReducer } from './itrustPayPaymentLogsReducer';
import { itrustPayReducer } from './itrustPayReducer';
import { integratedDevicesReducer } from './integratedDevicesReducer';

const itrustPayReducers = {
  itrustPay: itrustPayReducer,
  itrustPayPaymentLog: itrustPayPaymentLogsReducer,
  integratedDevices: integratedDevicesReducer,
};

export default itrustPayReducers;